import '../styles/Home.css';

const Home = () => {

    const pubUrl = process.env.PUBLIC_URL;

    return(
        <div className='wrapper'>
            <div className='hero'>
                <div className='hero-main' style={{backgroundImage: `url(${pubUrl}/media/hero.png)`}}>
                    <h2>Professional Roofing Services</h2>
                    <p>
                        We provide reliable residential and commercial roofing solutions designed to protect your property and withstand even the harshest weather conditions. From detailed inspections and minor repairs to full roof replacements, our experienced team is committed to delivering quality craftsmanship, durable materials, and dependable service on every project we take on.
                    </p>
                    <button>View Our Work</button>
                </div>
                <div className='hero-side'>
                    <div className='hero-side-tile'>
                        <img src={pubUrl+'/icons/ico1.png'} alt='roof installation icon'/>
                        <div className='hero-side-tile-cont'>
                            <h1>Roof Installation</h1>
                            <p>High-quality installations using durable, code-compliant materials.</p>
                        </div>
                    </div>
                    <div className='hero-side-tile'>
                        <img src={pubUrl+'/icons/ico2.png'} alt='roof repair icon'/>
                        <div className='hero-side-tile-cont'>
                            <h1>Roof Repairs</h1>
                            <p>Fast, dependable repairs for leaks, storm damage, and aging roofs.</p>
                        </div>
                    </div>
                    <div className='hero-side-tile'>
                        <img src={pubUrl+'/icons/ico3.png'} alt='project management icon'/>
                        <div className='hero-side-tile-cont'>
                            <h1>Project Management</h1>
                            <p>Clear communication, timelines, and clean job sites from start to finish.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='cta'>
                <h6>Get a Free Roofing Estimate</h6>
                <button>FREE QUOTE</button>
            </div>

            <div className='section top'>
                <div className='section-img' style={{backgroundImage: `url(${pubUrl}/media/img4.jpg)`}}/>
                <div className='section-large'>
                    <div className='section-cont'>
                        <h3>No Roofing Project Too Big or Small</h3>
                        <div className='line-short'/>
                        <div className='split'>
                            <div className='split-col'>
                                <p>
                                    Whether you need a small roof repair or a complete replacement, we approach every project with the same level of care, precision, and professionalism. No matter the size of the job, our goal is to deliver dependable results you can trust.
                                </p>
                                <p>
                                    Our experienced team works with homeowners, property managers, and businesses to provide durable, long-lasting roofing solutions. We communicate clearly, respect your property, and complete every project efficiently and responsibly.
                                </p>
                            </div>
                            <div className='split-col'>
                                <p>
                                    We specialize in both residential and commercial roofing systems, ensuring all work meets safety standards, building codes, and manufacturer specifications. From materials to installation, we focus on quality craftsmanship that stands up to time and weather.
                                </p>
                                <button>LEARN MORE</button>
                            </div>
                        </div>
                    </div>
                    <div className='section-banner'>
                        <div className='split-banner'>
                            <p>6</p>
                            <h6>Years of Experience</h6>
                        </div>
                        <div className='split-banner'>
                            <p>250+</p>
                            <h6>Projects Completed</h6>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section middle'>
                <h3>Recent Roofing Projects</h3>
                <div className='line-short'/>
                <div className='flex-cont'>
                    <div className='flex-tile'>
                        <div className='tile-img' style={{backgroundImage: `url(${pubUrl}/media/img5.jpg)`}}/>
                        <div className='tile-cont'>
                            <h6>Residential Roof Replacement</h6>
                            <p>
                                Full shingle replacement completed with upgraded
                                underlayment and improved ventilation.
                            </p>
                            <button>VIEW PROJECT</button>
                        </div>
                    </div>
                    <div className='flex-tile'>
                        <div className='tile-img' style={{backgroundImage: `url(${pubUrl}/media/img6.jpg)`}}/>
                        <div className='tile-cont'>
                            <h6>Commercial Flat Roofing</h6>
                            <p>
                                Durable flat roofing system installed for
                                long-term performance and water resistance.
                            </p>
                            <button>VIEW PROJECT</button>
                        </div>
                    </div>
                    <div className='flex-tile'>
                        <div className='tile-img' style={{backgroundImage: `url(${pubUrl}/media/img2.jpg)`}}/>
                        <div className='tile-cont'>
                            <h6>Storm Damage Repairs</h6>
                            <p>
                                Emergency repairs completed after severe weather
                                to prevent further interior damage.
                            </p>
                            <button>VIEW PROJECT</button>
                        </div>
                    </div>
                </div>
                <button>VIEW ALL</button>
            </div>

            <div className='section bottom'>
                <video src={pubUrl+'/media/video.mp4'} autoPlay muted loop/>
                <div className='split-cta'>
                    <h4>Trusted Roofing Contractors for Years</h4>
                    <div className='line-short'/>
                    <p>
                        Our company is built on a foundation of honesty, quality workmanship, and dependable service. We believe trust is earned through clear communication, fair pricing, and standing behind our work long after the project is complete.
                        <br/>
                        Every roof we install or repair is completed with attention to detail and a commitment to doing the job right the first time. We take pride in protecting homes and businesses with durable, high-quality roofing systems you can rely on for years to come.
                    </p>
                    <button>ABOUT US</button>
                </div>
                <div className='section-banner'>
                    <div className='split-banner left'>
                        <p>Call for a Free Estimate</p>
                        <h6>(713) 385 2814</h6>
                    </div>
                    <div className='split-banner white'>
                        <button>CONTACT FORM</button>
                    </div>
                </div>
            </div>

            <div className='section faq'>
                <div className='faq-small'>
                    <h2>Let’s Protect Your Property</h2>
                    <div className='line-short'/>
                    <p>
                        Have questions about your roof? Our team is ready to help
                        with inspections, repairs, and replacements.
                    </p>
                    <button>GET IN TOUCH</button>
                </div>
                <div className='faq-large'>
                    {/* COLLAPSIBLE FAQ MENU */}
                </div>
            </div>

            <div className='section reviews'>
                <h2>Customer Reviews</h2>
                <div className='line-short'/>
                <div className='flex-cont'>
                    <div className='review-tile'>
                        <h6>★ ★ ★ ★ ★</h6>
                        <p>
                            “The crew was professional, fast, and left the site
                            spotless. Our new roof looks great.”
                        </p>
                        <p>Homeowner</p>
                    </div>
                    <div className='review-tile'>
                        <h6>★ ★ ★ ★ ★</h6>
                        <p>
                            “Excellent communication and quality work from start
                            to finish. Highly recommend.”
                        </p>
                        <p>Property Manager</p>
                    </div>
                    <div className='review-tile'>
                        <h6>★ ★ ★ ★ ★</h6>
                        <p>
                            “They handled our commercial roofing project on time
                            and on budget.”
                        </p>
                        <p>Business Owner</p>
                    </div>
                </div>
            </div>

            <div className='logo-banner'>
                {/* Roofing Material & Certification Logos */}
            </div>
        </div>
    )
}

export default Home;
